import rootReducer from '../reducers';
import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { actionLogger } from "../middleware/actionLogger";


const store = createStore(
  rootReducer,
  applyMiddleware(thunk, actionLogger)
);

export default store;